import React, { PropsWithChildren, useMemo, useState } from 'react';
import DocumentPreviewContext from './DocumentPreviewContext';
import { DisplayedDocument, DocumentPreview } from './types';

const DocumentPreviewProvider: React.FunctionComponent<PropsWithChildren> = function ({
    children,
}) {
    const [documentPreview, setDocumentPreview] = useState<DocumentPreview | undefined>();
    const [previewLoading, setPreviewLoading] = useState<boolean>(false);
    const [listDocuments, setListDocuments] = useState<DisplayedDocument[]>([]);

    const contextValue = useMemo(
        () => ({
            previewLoading,
            setPreviewLoading,
            documentPreview,
            setDocumentPreview,
            listDocuments,
            setListDocuments,
        }),
        [
            documentPreview,
            setDocumentPreview,
            previewLoading,
            setPreviewLoading,
            listDocuments,
            setListDocuments,
        ],
    );

    return (
        <DocumentPreviewContext.Provider value={contextValue}>
            {children}
        </DocumentPreviewContext.Provider>
    );
};

export default DocumentPreviewProvider;
